export default {
  id:0,
  names:'',
  numberId:'',
  email:'',
  password:'',
  passconf:'',
  email_verified_at:'',
  language:'es',
  usr_role:0,
  com_id:0,
  photoURL:require("@/assets/images/portrait/small/avatar-s-11.jpg")
}
